import React, { FunctionComponent } from 'react';

import { i18n } from '../../../../../../../helpers/i18n';
import { UnsupportedBrowserStub } from '../../../unsupported-browser-stub';
import css from './styles.css';

export const SoundStub: FunctionComponent = () => {
    return (
        <UnsupportedBrowserStub
            className={css.stubWrapper}
            title={i18n('settings-v2', 'sound-change-not-supported-title')}
        />
    );
};
